<h2>Catálogo de Productos</h2>
<!--Table-->
<div class="card">

  <form [formGroup]="filterForm" class="mb-4 gap-2 p-4 surface-card shadow-2 border-round">
    <div class="formgroup-inline">

      <div class="field col-12 xl:col-4 flex flex-column gap-2">
        <label for="accountId" class="block font-bold mb-2">Cuenta</label>
        <p-select id="accountId" [options]="accounts" formControlName="accountId" placeholder="Selecciona una Cuenta"
          optionLabel="name" [resetFilterOnHide]="true" [filter]="true" lazy="true"
          (onFilter)="loadAccounts($event)" (onChange)="onAccountChange()" [showClear]="true"
          optionValue="accountId" [disabled]="!hasAccountAccess" [loading]="accountLoading" [fluid]="true"
          [appendTo]="'body'">
        </p-select>
        @if (hasEditAccess) {
          <button pButton type="button" label="Nuevo Producto" icon="pi pi-plus" severity="primary"
            class="w-6" (click)="openCreateDialog()" [disabled]="!filterForm.get('accountId')?.value"></button>
        }
      </div>

    </div>
  </form>

  <p-popover #overlay [style]="{width:'300px'}">
    <div class="dropdown-header">
      <div class="dropdown-header-left">
        <p-checkbox [(ngModel)]="selectAll" binary="true" (onChange)="onSelectAll($event)">
        </p-checkbox>
        <input type="text" pInputText placeholder="Buscar Columna" [(ngModel)]="columnSearchTerm"
          class="column-search-input">
      </div>
      <button pButton icon="pi pi-times" (click)="overlay.hide()" class="p-button-rounded p-button-text">
      </button>
    </div>
    <br>
      <div class="columns-list mb-2" style="max-height:200px; overflow:auto;">
        @for (col of filteredColumns; track col) {
          <div>
            @if (!col.alwaysVisible) {
              <div class="field-checkbox">
                <p-checkbox [(ngModel)]="col.visible" binary="true" [inputId]="'col-' + col.field"
                  (onChange)="onColumnToggle()" />
                <label [for]="'col-' + col.field">{{ col.header }}</label>
              </div>
            }
          </div>
        }
      </div>
      <div class="footer flex justify-content-end gap-2">
        <button pButton label="Limpiar" severity="secondary" (click)="onClearColumns()"></button>
        <button pButton label="Guardar" (click)="onSaveColumns(); overlay.hide()"></button>
      </div>
  </p-popover>

  <p-table #dt [value]="products" dataKey="productId" [paginator]="true" [rows]="tableRows"
    [rowsPerPageOptions]="[30, 50, 100, 200]" [totalRecords]="totalRecords" [lazy]="true"
    (onLazyLoad)="loadProducts($event)" [loading]="loading" [responsiveLayout]="'scroll'" [(first)]="firstPage"
    [sortOrder]="-1" [defaultSortOrder]="-1" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando del {first} al {last} de {totalRecords} Registros"
    styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped">
    <ng-template pTemplate="caption">
      <div class="flex align-items-center justify-content-between mb-2">
        <div class="flex align-items-center gap-3">
          <span>Administrar Productos</span>
        </div>
        <div class="flex gap-2">
          <p-button icon="pi pi-filter-slash" severity="secondary" pTooltip="Limpiar Filtros y Orden"
            (click)="dt.clear()">
          </p-button>
          <p-button icon="pi pi-download" severity="secondary" pTooltip="Exportar"
            [loading]="exportLoading" [disabled]="!totalRecords" (click)="exportExcel()">
          </p-button>
          <p-button icon="pi pi-map" (click)="overlay.toggle($event); onColumnToggle()"
            pTooltip="Mostrar Columnas">
          </p-button>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        @for (col of appliedTableColumns; track col) {
          <th [pSortableColumn]="col.sortable ? col.field : ''">
            <div class="flex align-items-center justify-content-between gap-2">
              <span>
                {{ col.header }}
                @if (col.sortable) {
                  <p-sortIcon [field]="col.field" />
                }
              </span>
              @switch (col.field) {
                @case ('productId') {
                  <p-columnFilter type="numeric" field="productId" display="menu"
                    [showOperator]="false" [showAddButton]="false" placeholder="Buscar ID"></p-columnFilter>
                }
                @case ('sku') {
                  <p-columnFilter type="text" field="sku" display="menu" matchMode="contains"
                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                    placeholder="Buscar SKU"></p-columnFilter>
                }
                @case ('description') {
                  <p-columnFilter type="text" field="description" display="menu" matchMode="contains"
                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                    placeholder="Buscar Descripción"></p-columnFilter>
                }
                @case ('variant') {
                  <p-columnFilter type="text" field="variant" display="menu" matchMode="contains"
                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                    placeholder="Buscar Variante"></p-columnFilter>
                }
                @case ('upc') {
                  <p-columnFilter type="text" field="upc" display="menu" matchMode="contains"
                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                    placeholder="Buscar UPC"></p-columnFilter>
                }
                @case ('uom') {
                  <p-columnFilter field="uom" matchMode="equals" display="menu" [showMatchModes]="false"
                    [showOperator]="false" [showAddButton]="false">
                    <ng-template pTemplate="filter" let-value let-filterCallback="filterCallback">
                      <p-select [ngModel]="value" [options]="uomOptions" placeholder="Selecciona"
                        [showClear]="true" [fluid]="true" (onChange)="filterCallback($event.value)"
                        (onClear)="filterCallback(null)"></p-select>
                    </ng-template>
                  </p-columnFilter>
                }
                @case ('category') {
                  <p-columnFilter field="category" matchMode="contains" display="menu" [showMatchModes]="false"
                    [showOperator]="false" [showAddButton]="false">
                    <ng-template pTemplate="filter" let-value let-filterCallback="filterCallback">
                      <p-autoComplete [ngModel]="value" [suggestions]="categoryFilterSuggestions"
                        (completeMethod)="searchFilterCategories($event)" [dropdown]="true" [minLength]="0"
                        placeholder="Buscar Categoría" [fluid]="true"
                        (ngModelChange)="filterCallback($event)"></p-autoComplete>
                    </ng-template>
                  </p-columnFilter>
                }
                @case ('stockQuantity') {
                  <p-columnFilter type="numeric" field="stockQuantity" display="menu"
                    [showOperator]="false" [showAddButton]="false" placeholder="Buscar En Stock"></p-columnFilter>
                }
                @case ('creationDate') {
                  <p-columnFilter type="date" field="creationDate" display="menu"
                    placeholder="Filtrar por fecha"></p-columnFilter>
                }
                @case ('updateDate') {
                  <p-columnFilter type="date" field="updateDate" display="menu"
                    placeholder="Filtrar por fecha"></p-columnFilter>
                }
                @case ('createdBy') {
                  <p-columnFilter type="text" field="createdBy" display="menu" matchMode="contains"
                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                    placeholder="Buscar Creado por"></p-columnFilter>
                }
              }
            </div>
          </th>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
      <tr>
        @for (col of appliedTableColumns; track col) {
          <td>
            @switch (col.type) {
              <!-- Number / row index -->
              @case ('number') {
                <span>
                  {{ col.field === 'rowIndex' ? rowIndex + 1 : resolveField(product, col.field) }}
                </span>
              }
              <!-- String -->
              @case ('string') {
                <span>
                  {{ resolveField(product, col.field) }}
                </span>
              }
              <!-- Date -->
              @case ('date') {
                <span>
                  {{ resolveField(product, col.field) | date:'dd/MMM/yyyy h:mm a' }}
                </span>
              }
              <!-- Actions -->
              @case ('actions') {
                <span>
                  <div class="flex gap-2 justify-content-center">
                    @if (hasEditAccess) {
                      <button pButton icon="pi pi-clone" severity="info" class="p-button-rounded p-button-xs"
                        pTooltip="Crear Variante" (click)="openVariantDialog(product)"
                        style="width: 30px; height: 30px; padding: 0;">
                      </button>
                      <button pButton icon="pi pi-pencil" severity="info" class="p-button-rounded p-button-xs"
                        pTooltip="Editar" (click)="openEditDialog(product)"
                        style="width: 30px; height: 30px; padding: 0;">
                      </button>
                    }
                    <!-- Historial button hidden for now, handling still TBD -->
                  </div>
                </span>
              }
            }
          </td>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="appliedTableColumns.length" class="text-center p-4">
          @if (!filterForm.get('accountId')?.value) {
            Selecciona una cuenta para ver su catálogo de productos.
          } @else {
            No se encontraron productos para los filtros seleccionados.
          }
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Dialog to create/edit a product or create a variant -->
<p-dialog [header]="dialogTitle" [(visible)]="productDialogVisible" [style]="{width: '480px'}" [modal]="true">
  <form [formGroup]="productForm" class="flex flex-column gap-3">
    <div class="field">
      <label for="sku" class="block font-bold mb-2">SKU</label>
      <input pInputText id="sku" formControlName="sku" maxlength="30" placeholder="Ingresa el SKU del producto"
        class="w-full">
    </div>

    <div class="field">
      <label for="description" class="block font-bold mb-2">Descripción <span class="req">*</span></label>
      <input pInputText id="description" formControlName="description" maxlength="60"
        placeholder="Ingresa la descripción del producto" class="w-full">
    </div>

    <div class="field">
      <label for="variant" class="block font-bold mb-2">Variante</label>
      <input pInputText id="variant" formControlName="variant" maxlength="60"
        placeholder="Ej. Azul, Talla M, 500ml" class="w-full">
    </div>

    <div class="field">
      <label for="upc" class="block font-bold mb-2">UPC</label>
      <input pInputText id="upc" formControlName="upc" maxlength="30"
        placeholder="Ingresa el código de barras de fábrica (UPC)" class="w-full">
    </div>

    <div class="field">
      <label for="uom" class="block font-bold mb-2">UOM (Medida Base) <span class="req">*</span></label>
      <p-select id="uom" [options]="uomOptions" formControlName="uom" placeholder="Selecciona la medida base"
        [fluid]="true"></p-select>
    </div>

    <div class="field">
      <label for="category" class="block font-bold mb-2">Categoría <span class="req">*</span></label>
      <p-autoComplete id="category" formControlName="category" [suggestions]="categorySuggestions"
        (completeMethod)="searchCategories($event)" [dropdown]="true" [minLength]="0"
        placeholder="Busca o escribe una nueva categoría" [fluid]="true"></p-autoComplete>
    </div>

    @if (isVariantUnchanged) {
      <small class="p-error">La variante debe tener al menos un dato distinto al del producto original.</small>
    }
  </form>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancelar" severity="secondary"
      (click)="productDialogVisible = false"></button>
    <button pButton type="button" label="Guardar" [disabled]="productForm.invalid || isVariantUnchanged"
      (click)="save()"></button>
  </ng-template>
</p-dialog>

<!-- Dialog to show product movements -->
<p-dialog header="Historial de movimientos {{ this.selectedProduct?.sku }}" [(visible)]="historyDialogVisible"
  [style]="{width: '500px'}" [modal]="true" contentStyleClass="movements-dialog-content">
  <div class="stat-panel">
    <div class="stat-tile">
      <span class="stat-icon"><i class="pi pi-arrow-down-left"></i></span>
      <span class="stat-label">Recibidos</span>
      <span class="stat-value">{{ this.selectedProduct?.receivedQuantity }}</span>
    </div>
    <p-divider layout="vertical" />
    <div class="stat-tile">
      <span class="stat-icon"><i class="pi pi-box"></i></span>
      <span class="stat-label">En Inventario</span>
      <span class="stat-value">{{ this.selectedProduct?.registeredQuantity }}</span>
    </div>
    <p-divider layout="vertical" />
    <div class="stat-tile">
      <span class="stat-icon"><i class="pi pi-verified"></i></span>
      <span class="stat-label">En Stock</span>
      <span class="stat-value">{{ this.selectedProduct?.stockQuantity }}</span>
    </div>
  </div>

  <div class="movements-scroll">
    <p-timeline [value]="movements" align="left" styleClass="movements-timeline">

      <ng-template pTemplate="marker" let-movement>
        <span class="movement-marker"
          [ngClass]="movement.movementType === 'RELEASE' ? 'movement-marker-release' : 'movement-marker-update'">
          <i class="pi"
          [ngClass]="movement.movementType === 'RELEASE' ? 'pi-arrow-up-right' : 'pi-pencil'"></i>
        </span>
      </ng-template>

      <ng-template pTemplate="content" let-movement>
        <div class="movement-card">
          <div class="movement-card-header">
            <span class="movement-title">
              @if (movement.movementType === 'RELEASE') {
                Salida de {{ movement.quantity
                }}
              }
              @if (movement.movementType === 'UPDATE') {
                Edición
              }
            </span>
            <small class="text-surface-500 dark:text-surface-400">{{ (movement.movementTime ||
            movement.creationTime) | date:'dd/MMM/yyyy h:mm a' }}</small>
          </div>

          @if (movement.movementType === 'UPDATE') {
            <div class="movement-card-body">
              @for (field of movement.changeDetail | keyvalue; track field) {
                <div class="movement-change">
                  <span class="movement-change-label">{{ getFieldLabel($any(field.key)) }}:</span>
                  <span class="movement-change-value">"{{ getFieldValue($any(field.value)?.old)
                  }}" → "{{ getFieldValue($any(field.value)?.new) }}"</span>
                </div>
              }
            </div>
          }

          <div class="movement-card-footer">
            <small class="text-surface-500 dark:text-surface-400">por {{ movement.user }}</small>
            @if (movement.movementReason) {
              <div class="movement-reason">
                <i><strong>Nota: </strong>{{ movement.movementReason }}</i>
              </div>
            }
          </div>
        </div>
      </ng-template>

    </p-timeline>
  </div>
</p-dialog>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
